import { useState } from 'react';
import { createContexts } from '@/js/libs/create-contexts';
export const { usePuzzleNavigationContext } = createContexts({
    PuzzleNavigation({ isCollapsedNav, collapseMainNav }) {
        const [activeKey, setActiveKey] = useState(null);
        return {
            activeKey,
            setActiveKey,
            isCollapsedNav,
            collapseMainNav,
        };
    },
});
